export default __webpack_public_path__ + "static/media/img-slider-urban-transit-3.7c7e7468.png";